/**
 * It validates the form values and returns an object with the errors
 * @param formValues - The values of the form.
 * @returns An object with the errors.
 */
const signupValidations = (formValues) => {
  const errors = {};
  const emailRegex = /\S+@\S+\.\S+/;

  // First name
  if (!formValues.name.trim()) {
    errors.name = "El nombre es obligatorio";
  }

  if (formValues.name.length > 70) {
    errors.name = "El nombre debe contener máximo 70 caracteres";
  }

  // Last name
  if (!formValues.lastName.trim()) {
    errors.lastName = "El apellido es obligatorio";
  }

  if (formValues.lastName.length > 70) {
    errors.lastName = "El apellido debe contener máximo 70 caracteres";
  }

  // Age
  if (!formValues.age > 0) {
    errors.age = "La edad es obligatoria";
  }

  if (formValues.age && isNaN(formValues.age)) {
    errors.age = "La edad debe ser un número";
  }

  if (formValues.age > 130) {
    errors.age = "La edad no puede ser mayor a 130";
  }

  // Gender
  if (!formValues.gender.trim()) {
    errors.gender = "El género es obligatorio";
  }

  // Email
  if (!formValues.email.trim()) {
    errors.email = "El correo electrónico es obligatorio";
  }

  if (formValues.email && !emailRegex.test(formValues.email)) {
    errors.email = "El correo electrónico no es válido";
  }

  if (formValues.email.length > 120) {
    errors.email = "El correo electrónico debe contener máximo 120 caracteres";
  }

  // Telephone
  if (!formValues.telephone > 0) {
    errors.telephone = "El número de teléfono es obligatorio";
  }

  if (formValues.telephone && isNaN(formValues.telephone)) {
    errors.telephone = "El número de teléfono debe ser un número";
  }

  if (formValues.telephone && formValues.telephone.toString().length !== 10) {
    errors.telephone = "El número de teléfono debe tener 10 caracteres";
  }

  // Password

  if (!formValues.password.trim()) {
    errors.password = "La contraseña es obligatoria";
  }

  if (formValues.password && formValues.password.length < 6) {
    errors.password = "La contraseña debe contener mínimo 6 caracteres";
  }

  // Password confirmation

  if (!formValues.password2.trim()) {
    errors.password2 = "La confirmación de contraseña es obligatoria";
  }

  if (formValues.password !== formValues.password2) {
    errors.password = "Las contraseñas no coinciden";
  }

  // Is first home
  if (typeof formValues.isFirstHome !== "boolean") {
    errors.isFirstHome = "Esta opción es obligatoria";
  }

  // Has ingreso
  if (typeof formValues.hasIngreso !== "boolean") {
    errors.hasIngreso = "Esta opción es obligatoria";
  }

  // Ingreso amount
  if (formValues.hasIngreso && !formValues.ingresoAmount > 0) {
    errors.ingresoAmount = "Monto del ingreso familiar obligatorio";
  }

  if (formValues.hasIngreso && isNaN(formValues.ingresoAmount)) {
    errors.ingresoAmount = "El monto del ingreso familiar debe ser un número";
  }

  // Has cesantias
  if (typeof formValues.hasCesantias !== "boolean") {
    errors.hasCesantias = "Esta opción es obligatoria";
  }

  // Cesantias amount
  if (formValues.hasCesantias && !formValues.cesantiasAmount > 0) {
    errors.cesantiasAmount = "Monto de cesantías obligatorio";
  }

  if (formValues.hasCesantias && isNaN(formValues.cesantiasAmount)) {
    errors.cesantiasAmount = "El monto de cesantías debe ser un número";
  }

  // Has savings account
  if (typeof formValues.hasSavingsAccount !== "boolean") {
    errors.hasSavingsAccount = "Esta opción es obligatoria";
  }

  // Savings amount
  if (formValues.hasSavingsAccount && !formValues.savingsAmount > 0) {
    errors.savingsAmount = "Monto de tus ahorros obligatorio";
  }

  if (formValues.hasSavingsAccount && isNaN(formValues.savingsAmount)) {
    errors.savingsAmount = "El monto de tus ahorros debe ser un número";
  }

  // City
  if (!formValues.city.trim()) {
    errors.city = "Esta opción es obligatoria";
  }

  // Purchase reason
  if (!formValues.purchaseReason.trim()) {
    errors.purchaseReason = "El motivo de compra es obligatorio";
  }

  return errors;
};

export default signupValidations;
